import React from 'react';

function LearnerHelpModal({ isOpen, onClose }) {
  if (!isOpen) return null;

  return (
    <div style={{
      position: 'fixed', top: 0, left: 0, width: '100%', height: '100%',
      backgroundColor: 'rgba(0, 0, 0, 0.5)', display: 'flex', justifyContent: 'center',
      alignItems: 'center', zIndex: 2000, padding: '20px'
    }}>
      <div style={{
        background: '#ffffff', padding: '30px', borderRadius: '16px', maxWidth: '650px',
        width: '100%', maxHeight: '85vh', overflowY: 'auto', boxShadow: '0 20px 25px rgba(0,0,0,0.1)'
      }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
          <h2 style={{ fontSize: '1.5rem', fontWeight: '800', color: '#1e293b' }}>📖 Learner Portal Guide</h2>
          <button onClick={onClose} style={{ background: 'none', border: 'none', fontSize: '1.5rem', cursor: 'pointer', color: '#64748b' }}>&times;</button>
        </div>

        <div style={{ display: 'flex', flexDirection: 'column', gap: '16px', color: '#475569', fontSize: '0.95rem', lineHeight: '1.6' }}>
          <div>
            <h3 style={{ color: '#0f172a', fontSize: '1.1rem', fontWeight: '700', marginBottom: '4px' }}>1️⃣ Profile Settings</h3>
            <p>Click the <b>⚙️ Settings</b> button in the top right when you first log in to update your profile details. Set your new password, home address, telephone, emergency contact and enter your theory/practical test dates or prior driving experience so the system can accurately track your learning hours.</p>
          </div>

          <div>
            <h3 style={{ color: '#0f172a', fontSize: '1.1rem', fontWeight: '700', marginBottom: '4px' }}>2️⃣ Tab 1: Weekly Calendar Grid, Booking & Cancellations</h3>
            <p>Use the calendar grid to view available slots and click any blank square to book individual lessons, pick your hours and select your pickup location. You can also click on your own booked lessons directly on the grid to cancel them set by the instructor's cancellation policy timeframe. On the right-hand sidebar, use the "Direct Chat" to instantly send and receive messages with your instructor.</p>
          </div>

          <div>
            <h3 style={{ color: '#0f172a', fontSize: '1.1rem', fontWeight: '700', marginBottom: '4px' }}>3️⃣ Tab 2: Month Bulk Booking</h3>
            <p>Want to book multiple lessons ahead of time? Switch to the Month Bulk Booking tab to set up a recurring package schedule, review your staging cart and submit them all at once.</p>
          </div>

          <div>
            <h3 style={{ color: '#0f172a', fontSize: '1.1rem', fontWeight: '700', marginBottom: '4px' }}>4️⃣ Tab 3: Progress & Reporting Hub</h3>
            <p>Track your core competency mastery, view test-readiness gates and use the dropdown menu to review past lesson notes and instructor feedback. You can also click "Print Progress Report" anytime to generate an official summary sheet for yourself.</p>
          </div>
        </div>

        <div style={{ marginTop: '30px', textAlign: 'right' }}>
          <button onClick={onClose} style={{ padding: '10px 20px', backgroundColor: '#0066cc', color: '#fff', border: 'none', borderRadius: '8px', fontWeight: 'bold', cursor: 'pointer' }}>
            Got It, Thanks!
          </button>
        </div>
      </div>
    </div>
  );
}

export default LearnerHelpModal;